import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { WebsiteStatus } from 'src/app/models/data/website-status';
import { PageService } from 'src/app/services/page/page.service';
import { DropdownService } from 'src/app/services/dropdown/dropdown.service';
import { RouterModule, Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
  imports: [CommonModule, RouterModule],
})
export class HomeComponent implements OnInit {
  websiteStatuses: WebsiteStatus[] = [];
  optionsInCycle: string[] = [];
  errorMessage: string = '';
  firstSurveyRoute: string = ''; // Dynamic route from API

  constructor(
    private pageService: PageService,
    private dropService: DropdownService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.pageService.fetchWebsiteStatuses();
    this.pageService.websiteStatuses.subscribe((websiteStatuses) => {
      if (websiteStatuses) {
        this.websiteStatuses = websiteStatuses;

        let currentCycleStatuses: WebsiteStatus[] = this.websiteStatuses.filter(
          (x) => x.CurrentCycleID > 0,
        );
        if (currentCycleStatuses.length > 0) {
          this.optionsInCycle = currentCycleStatuses.map((x) =>
            x.Option.toUpperCase(),
          );
        }
      }
    });

    // Get the first survey route from dropdown service (which gets it from API)
    this.dropService.pageNav.forEach((nav) => {
      if (nav.name === 'Survey' && nav.route) {
        this.firstSurveyRoute = nav.route;
      }
    });

    // Also subscribe to page service to get first page route directly
    this.pageService.pages.subscribe((pages) => {
      if (pages && pages.length > 0) {
        const firstPage = pages[0];
        this.firstSurveyRoute = firstPage.Route.startsWith('/') 
          ? firstPage.Route 
          : `/${firstPage.Route}`;
      }
    });
  }

  ngOnInit(): void {
    // Check for route not found error
    this.route.queryParams.subscribe(params => {
      if (params['error'] === 'page-not-found') {
        this.errorMessage = 'The requested page is no longer available. Please select a page from the navigation menu.';
        // Clear the error param from URL
        this.router.navigate(['/home'], { replaceUrl: true });
      }
    });
  }
}
